module.exports = __webpack_public_path__ + "img/info.e87a49b8.svg";